import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../App";
import { TextField, Select, FormControl, InputLabel, MenuItem, Button, Paper, Typography, Box, Grid, Tabs, Tab, Container, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";

export default function SchemeCreate() {
    const login_id = localStorage.getItem("USER_ID");

    const [formData, setFormData] = useState({ SchemeName: "", GroupType: "", FromDate: "", ToDate: "", RedemptionTill: "", MinRedeemPoints: "", LoginID: login_id });
    const [formUpdateData, setFormUpdateData] = useState({ SchemeName: "", Category: "", RetailerType: "" });
    const [quantityPoints, setQuantityPoints] = useState([{ FromQuantity: "", ToQuantity: "", Points: "" }]);
    const [QtyGroups, setQtyGroups] = useState([{ QtyGroupName: "", FromQty: "", ToQty: "" }]);

    const [IsDisable, setIsDisable] = useState(false);
    const [openDateGroup, setOpenQtyGroup] = useState(false);
    const [selectedQtyGroup, SetSelectedQtyGroup] = useState("");
    const [QtyGroupNameList, setQtyGroupNameList] = useState([]);

    const [tabIndex, setTabIndex] = useState(0);
    const [SchemeList, setSchemeList] = useState([]);
    const [CategoryList, setCategoryList] = useState([]);
    const [RetailerTypeList, setRetailerTypeList] = useState([]);

    const [AllSchemeList, setAllSchemeList] = useState([]);

    useEffect(() => {
        if (tabIndex === 1) {
            LoadUpdateSchemeData();
            setFormData({ SchemeName: "", GroupType: "", FromDate: "", ToDate: "", RedemptionTill: "", MinRedeemPoints: "", LoginID: login_id });
        } else if (tabIndex === 3) {
            LoadSchemeList();
        } else {
            setFormUpdateData({ SchemeName: "", Category: "", RetailerType: "" });
        }
    }, [tabIndex]);

    useEffect(() => {
        if (openDateGroup === true) {
            LoadQtyGroupNameList();
        }
    }, [openDateGroup]);


    const LoadSchemeList = () => {
        const data = {
            Type: "AllSchemeList"
        };

        axios.post(BASE_URL + '/SchemeQtyGroupListLoad', data).then(response => {
            setAllSchemeList(response.data?.Data ?? []);
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "warning",
                    text: `Error: ${error.response.data.message}`
                });
            } else if (error.request) {
                Swal.fire({
                    icon: "warning",
                    text: `No response received`
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    text: error.message
                });
            }
        });
    }

    const handleStatusChange = async (id, currentStatus) => {
            try {
                const newStatus = currentStatus == 1 ? 0 : 1;
                
                // Replace this with your API URL and payload structure
                const response = await axios.post(BASE_URL + '/SchemeQtyGroupListLoadupdateStatus', { id, newStatus });
                
                if (response.status == 200) {
                    LoadSchemeList();
                } else {
                    alert("Error updating status");
                }
            } catch (error) {
                console.error("Error during status update:", error);
                alert("Failed to update status");
            }
        };


    const LoadQtyGroupNameList = () => {

        const data = {
            Type: "ListName"
        };

        axios.post(BASE_URL + '/SchemeQtyGroupListLoad', data).then(response => {
            setQtyGroupNameList(response.data?.Data ?? []);
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "warning",
                    text: `Error: ${error.response.data.message}`
                });
            } else if (error.request) {
                Swal.fire({
                    icon: "warning",
                    text: `No response received`
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    text: error.message
                });
            }
        });
    }

    const handleRowChange = (index, e) => {
        const { name, value } = e.target;
        setQuantityPoints((prev) => {
            const updated = [...prev];
            updated[index][name] = value;
            return updated;
        });
    };

    const addRow = () => {
        setQuantityPoints((prev) => [...prev, { FromQuantity: "", ToQuantity: "", Points: "" }]);
    };

    const removeRow = (index) => {
        setQuantityPoints((prev) => prev.filter((_, i) => i !== index));
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleUpdateChange = (e) => {
        setFormUpdateData({ ...formUpdateData, [e.target.name]: e.target.value });
    };

    const SchemeRetailerType = (e) => {
        axios.post(BASE_URL + '/SchemeNameValidate', { SchemeName: e.target.value }).then(response => {
            setIsDisable(response.data?.Data === "ELECTRICIAN" ? true : false);
            setFormUpdateData({ ...formUpdateData, SchemeName: e.target.value, RetailerType: response.data?.Data === "ELECTRICIAN" && "High" });
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "warning",
                    text: `Error: ${error.response.data.message}`
                });
            } else if (error.request) {
                Swal.fire({
                    icon: "warning",
                    text: `No response received`
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    text: error.message
                });
            }
        });

    }

    const handleSubmit = async () => {
        if (!formData.SchemeName || !formData.GroupType || !formData.FromDate || !formData.ToDate || !formData.RedemptionTill || !formData.MinRedeemPoints) {
            Swal.fire("Warning", "Please fill all fields!", "warning");
            return false;
        } else if (!formData.LoginID) {
            Swal.fire("Warning", "Invalid Login Details!", "warning");
            return false;
        }

        axios.post(BASE_URL + '/WireSchemeCreate', formData).then(response => {
            if (response.status === 200) {
                Swal.fire("Success", "Scheme Created Successfully!", "success");
                setFormData({ SchemeName: "", GroupType: null, FromDate: "", ToDate: "", RedemptionTill: "", MinRedeemPoints: "" });
            }
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "warning",
                    text: `Error: ${error.response.data.message}`
                });
            } else if (error.request) {
                Swal.fire({
                    icon: "warning",
                    text: `No response received`
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    text: error.message
                });
            }
        });
    };

    const LoadUpdateSchemeData = () => {
        axios.post(BASE_URL + '/UpdateSchemeDataLoad').then(response => {
            setSchemeList(response.data?.SchemeList ?? []);
            setCategoryList(response.data?.CategoryList ?? []);
            setRetailerTypeList(response.data?.RetailerTypeList ?? []);
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "warning",
                    text: `Error: ${error.response.data.message}`
                });
            } else if (error.request) {
                Swal.fire({
                    icon: "warning",
                    text: `No response received`
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    text: error.message
                });
            }
        });
    }

    const handleUpdate = async () => {
        if (!formUpdateData.SchemeName || !formUpdateData.Category || !formUpdateData.RetailerType) {
            Swal.fire("Warning", "Please fill all fields!", "warning");
            return;
        }

        for (let i = 0; i < quantityPoints.length; i++) {
            const row = quantityPoints[i];
            if (!row.FromQuantity || !row.ToQuantity || !row.Points) {
                Swal.fire("Warning", `Please fill all fields in row ${i + 1}!`, "warning");
                return;
            }
            // Optional: Validate that numbers are > 0
            if (Number(row.FromQuantity) <= 0 || Number(row.ToQuantity) <= 0 || Number(row.Points) <= 0) {
                Swal.fire("Warning", `Values in row ${i + 1} must be greater than 0!`, "warning");
                return;
            }
            // Optional: Validate that FromQuantity < ToQuantity
            if (Number(row.FromQuantity) >= Number(row.ToQuantity)) {
                Swal.fire("Warning", `Row ${i + 1}: "From Quantity" must be less than "To Quantity"!`, "warning");
                return;
            }
        }

        const payload = {
            ...formUpdateData,
            QuantityPoints: quantityPoints,
            LoginID: login_id
        };

        axios.post(BASE_URL + '/UpdateSchemeConfig', payload)
            .then(response => {
                Swal.fire("Success", "Scheme Updated Successfully!", "success");
                setFormUpdateData({ SchemeName: "", Category: "", RetailerType: "" });
                setQuantityPoints([{ FromQuantity: "", ToQuantity: "", Points: "" }]);
            })
            .catch(error => {
                Swal.fire("Error", error.response?.data?.message || "Update failed", "error");
            });
    };


    // -----------------------------------------------------------------------
    const handleQtyMasterChange = (index, event) => {
        const { name, value } = event.target;
        const updatedGroups = [...QtyGroups];
        updatedGroups[index][name] = value;
        setQtyGroups(updatedGroups);
    };

    const addQtyNewRow = () => {
        const lastRow = QtyGroups[QtyGroups.length - 1];
        setQtyGroups([...QtyGroups, { QtyGroupName: lastRow?.QtyGroupName || "", FromQty: "", ToQty: "" }]);
    };

    const removeQtyRow = (index) => {
        const updatedGroups = QtyGroups.filter((_, i) => i !== index);
        setQtyGroups(updatedGroups);
    };

    // Validation function
    const validateDateGroups = () => {
        const errors = [];

        QtyGroups.forEach((group, index) => {
            if (!group.QtyGroupName) {
                errors.push(`Row ${index + 1}: Quantity Group Name is required`);
            }
            if (!group.FromQty) {
                errors.push(`Row ${index + 1}: From QTY is required`);
            }
            if (!group.ToQty) {
                errors.push(`Row ${index + 1}: To QTY is required`);
            }
            if (group.FromQty && group.ToQty && group.FromQty > group.ToQty) {
                errors.push(`Row ${index + 1}: From Date cannot be after To Date`);
            }
        });

        return errors;
    };

    // Submit handler
    const handleDateMasterUpdate = async () => {
        const errors = validateDateGroups();

        if (errors.length > 0) {
            Swal.fire({
                title: "Validation Errors",
                html: errors.map((e) => `<p style="text-align:left;">• ${e}</p>`).join(""),
                icon: "error",
                confirmButtonText: "OK",
            });
            return;
        }

        console.log("Final Date Groups:", QtyGroups);
        const payload = {
            QtyGroups: QtyGroups,
            LoginID: login_id
        };

        axios.post(BASE_URL + '/SchemeQtyGroupInsert', payload)
            .then(response => {
                Swal.fire("Success", "Date Group Added Successfully!", "success");
                setQtyGroups([{ QtyGroupName: "", FromQty: "", ToQty: "" }]);
            })
            .catch(error => {
                Swal.fire("Error", error.response?.data?.message || "Update failed", "error");
            });
    };


    const handleQtyGroupSelect = async () => {
        const data = {
            Type: "QtyList",
            GroupName: selectedQtyGroup
        };

        axios.post(BASE_URL + '/SchemeQtyGroupListLoad', data).then(response => {
            const apiData = response.data?.Data ?? [];
            const updatedGroups = apiData.map((item) => ({
                FromQuantity: item.FromQty,
                ToQuantity: item.ToQty,
                Points: ""
            }));
            setQuantityPoints(apiData.length > 0 ? updatedGroups : []);
        }).catch(error => {
            if (error.response) {
                Swal.fire({
                    icon: "warning",
                    text: `Error: ${error.response.data.message}`
                });
            } else if (error.request) {
                Swal.fire({
                    icon: "warning",
                    text: `No response received`
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    text: error.message
                });
            }
        });
    };


    return (
        <>
            <Paper
                elevation={4}
                sx={{
                    position: "sticky",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1100,
                    borderRadius: 0,
                    backgroundColor: "#f5f5f5",
                    boxShadow: "0px 2px 10px rgba(0,0,0,0.05)"
                }}
            >
                <Tabs
                    value={tabIndex}
                    onChange={(e, newValue) => setTabIndex(newValue)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="scrollable"
                    scrollButtons={false}
                    sx={{
                        ".MuiTabs-flexContainer": {
                            justifyContent: "flex-start"
                        }
                    }}
                >
                    <Tab label="Create Scheme" />
                    <Tab label="Scheme Config" />
                    <Tab label="From & To Quantity Master" />
                    <Tab label="Scheme Master" />
                </Tabs>
            </Paper>
            <Container >
                <Box mt={3} mb={3}>
                    <Paper elevation={6} sx={{ p: 4, borderRadius: "20px", }}>
                        {tabIndex === 0 && (
                            <>
                                <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 600 }}>
                                    Create Wire QR-Based Scheme
                                </Typography>

                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Scheme Name"
                                            name="SchemeName"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            value={formData.SchemeName}
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Group Type</InputLabel>
                                            <Select
                                                name="GroupType"
                                                value={formData.GroupType}
                                                label="Group Type"
                                                onChange={handleChange}
                                            >
                                                <MenuItem value="ELECTRICIAN">ELECTRICIAN</MenuItem>
                                                <MenuItem value="RETAILER">RETAILER</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            label="From Date"
                                            name="FromDate"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            value={formData.FromDate}
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            label="To Date"
                                            name="ToDate"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            value={formData.ToDate}
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            label="Redemption Valid Till"
                                            name="RedemptionTill"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            value={formData.RedemptionTill}
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            label="Minimum Redeem Points"
                                            name="MinRedeemPoints"
                                            type="number"
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            value={formData.MinRedeemPoints}
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            size="small"
                                            onClick={handleSubmit}
                                            sx={{
                                                fontWeight: 600,
                                                backgroundColor: "#1976d2",
                                                ":hover": {
                                                    backgroundColor: "#1565c0"
                                                }
                                            }}
                                        >
                                            Create Scheme
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        )}

                        {tabIndex === 1 && (
                            <>
                                <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 600 }}>
                                    Wire QR-Based Scheme Config
                                </Typography>

                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Scheme Name</InputLabel>
                                            <Select
                                                label="Scheme Name"
                                                name="SchemeName"
                                                value={formUpdateData.SchemeName}
                                                onChange={(e) => {
                                                    handleUpdateChange(e);
                                                    SchemeRetailerType(e);
                                                }}
                                            >
                                                {SchemeList.map((row) => (
                                                    <MenuItem key={row.Value} value={row.Value}>{row.Label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Category</InputLabel>
                                            <Select
                                                label="Category"
                                                name="Category"
                                                value={formUpdateData.Category}
                                                onChange={handleUpdateChange}
                                            >
                                                {CategoryList.map((row) => (
                                                    <MenuItem key={row.Value} value={row.Value}>{row.Label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Retailer Type</InputLabel>
                                            <Select
                                                label="Retailer Type"
                                                name="RetailerType"
                                                value={formUpdateData.RetailerType}
                                                onChange={handleUpdateChange}
                                                disabled={IsDisable}
                                            >
                                                {RetailerTypeList.map((row) => (
                                                    <MenuItem key={row.Value} value={row.Value}>{row.Label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        {/* Date Group Label - Floated Right */}
                                        <Box
                                            sx={{
                                                ml: 2,
                                                cursor: "pointer",
                                                color: "primary.main",
                                                fontWeight: 600,
                                                textDecoration: "underline",
                                                whiteSpace: "nowrap",
                                                float: 'right'
                                            }}
                                            onClick={() => setOpenQtyGroup(true)}
                                        >
                                            Load Date Group
                                        </Box>
                                    </Grid>

                                    {quantityPoints.map((row, index) => (
                                        <React.Fragment key={index}>
                                            <Grid item xs={3}>
                                                <TextField
                                                    label="From Quantity"
                                                    name="FromQuantity"
                                                    type="number"
                                                    size="small"
                                                    fullWidth
                                                    value={row.FromQuantity}
                                                    onChange={(e) => handleRowChange(index, e)}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField
                                                    label="To Quantity"
                                                    name="ToQuantity"
                                                    type="number"
                                                    size="small"
                                                    fullWidth
                                                    value={row.ToQuantity}
                                                    onChange={(e) => handleRowChange(index, e)}
                                                />
                                            </Grid>
                                            <Grid item xs={3}>
                                                <TextField
                                                    label="Points"
                                                    name="Points"
                                                    type="number"
                                                    size="small"
                                                    fullWidth
                                                    value={row.Points}
                                                    onChange={(e) => handleRowChange(index, e)}
                                                />
                                            </Grid>
                                            <Grid item xs={3} display="flex" alignItems="center">
                                                {quantityPoints.length > 1 && (
                                                    <IconButton color="error" onClick={() => removeRow(index)}>
                                                        <RemoveCircle />
                                                    </IconButton>
                                                )}
                                                {index === quantityPoints.length - 1 && (
                                                    <IconButton color="primary" onClick={addRow}>
                                                        <AddCircle />
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        </React.Fragment>
                                    ))}

                                    <Grid item xs={12}>
                                        <Button variant="contained" fullWidth size="small" onClick={handleUpdate} sx={{ fontWeight: 600 }}>
                                            Update Scheme
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        )}

                        {tabIndex === 2 && (
                            <Grid container spacing={2} mt={1}>
                                {QtyGroups.map((group, index) => (
                                    <React.Fragment key={index}>
                                        <Grid item xs={3}>
                                            <FormControl fullWidth size="small">
                                                <TextField
                                                    label="Quantity Group Name"
                                                    name="QtyGroupName"
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    value={group.QtyGroupName}
                                                    onChange={(e) => handleQtyMasterChange(index, e)}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={3}>
                                            <FormControl fullWidth size="small">
                                                <TextField
                                                    label="From Quantity"
                                                    name="FromQty"
                                                    type="number"
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={group.FromQty}
                                                    onChange={(e) => handleQtyMasterChange(index, e)}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={3}>
                                            <FormControl fullWidth size="small">
                                                <TextField
                                                    label="To Quantity"
                                                    name="ToQty"
                                                    type="number"
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={group.ToQty}
                                                    onChange={(e) => handleQtyMasterChange(index, e)}
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={3} display="flex" alignItems="center">
                                            {QtyGroups.length > 1 && (
                                                <IconButton color="error" onClick={() => removeQtyRow(index)}>
                                                    <RemoveCircle />
                                                </IconButton>
                                            )}
                                            {index === QtyGroups.length - 1 && (
                                                <IconButton color="primary" onClick={addQtyNewRow}>
                                                    <AddCircle />
                                                </IconButton>
                                            )}
                                        </Grid>
                                    </React.Fragment>
                                ))}

                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        size="small"
                                        onClick={handleDateMasterUpdate}
                                        sx={{ fontWeight: 600 }}
                                    >
                                        Update Quantity List
                                    </Button>
                                </Grid>
                            </Grid>
                        )}

                        {tabIndex === 3 && (
                            <>
                                <center><b><u>Scheme List</u></b></center>
                                <div className='mt-4'>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><b>Scheme Name</b></TableCell>
                                                    <TableCell><b>Group Type</b></TableCell>
                                                    <TableCell><b>From Date</b></TableCell>
                                                    <TableCell><b>To Date</b></TableCell>
                                                    {/* <TableCell><b>Redemption Valid</b></TableCell>
                                                    <TableCell><b>Min Redeem Points</b></TableCell> */}
                                                    {/* <TableCell><b>Active Status</b></TableCell> */}
                                                    <TableCell><b>Action</b></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {AllSchemeList && AllSchemeList.length > 0 ? (
                                                    (AllSchemeList && AllSchemeList.map((data) => (
                                                        <TableRow key={data.PG_code} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell>{data.SchemeName}</TableCell>
                                                            <TableCell>{data.GroupType}</TableCell>
                                                            <TableCell>{data.FromDate}</TableCell>
                                                            <TableCell>{data.ToDate}</TableCell>
                                                            {/* <TableCell>{data.RedmptionValidTill}</TableCell>
                                                            <TableCell>{data.MinimumRedeemPTS}</TableCell> */}
                                                            {/* <TableCell>{data.Active_Status}</TableCell> */}
                                                            <TableCell>
                                                                <button
                                                                    onClick={() => handleStatusChange(data.id, data.Active_Status)}
                                                                    style={{
                                                                        backgroundColor: data.Active_Status == "1" ? "green" : "red",
                                                                        color: "white",
                                                                        padding: "5px 10px",
                                                                        border: "none",
                                                                        cursor: "pointer"
                                                                    }}
                                                                >
                                                                    {data.Active_Status == "1" ? 'Active' : 'Inactive'}
                                                                </button>
                                                              </TableCell>
                                                            {/* <TableCell>-</TableCell> */}
                                                        </TableRow>
                                                    )))
                                                ) : (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell align="center" colSpan={20}>
                                                            <b className='text-danger'>No Data Found.!</b>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                                {/* {AllSchemeList.map((row) => (
                                                <TableRow
                                                key={row.name}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row">
                                                    {row.name}
                                                </TableCell>
                                                <TableCell align="right">{row.calories}</TableCell>
                                                <TableCell align="right">{row.fat}</TableCell>
                                                <TableCell align="right">{row.carbs}</TableCell>
                                                <TableCell align="right">{row.protein}</TableCell>
                                                </TableRow>
                                            ))} */}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </>
                        )}
                    </Paper>
                </Box>
            </Container>
            <Dialog
                open={openDateGroup}
                onClose={() => setOpenQtyGroup(false)}
                maxWidth="xs"
                fullWidth
                PaperProps={{ sx: { borderRadius: 3, p: 1.5, backgroundColor: "#fafafa", boxShadow: "0px 4px 20px rgba(0,0,0,0.15)" } }}
            >
                <DialogContent sx={{ textAlign: "center", pb: 0 }}>
                    <Box sx={{ mb: 2 }}>
                        <Box component="h2" sx={{ fontSize: "1.3rem", fontWeight: 700, color: "primary.main", mb: 1 }} >
                            Select Quantity Group Name
                        </Box>
                        <Box sx={{ fontSize: "0.9rem", color: "text.secondary" }}>
                            Choose a date group name to automatically load related data.
                        </Box>
                    </Box>

                    <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                        <InputLabel>Quantity Group Name</InputLabel>
                        <Select
                            label="Quantity Group Name"
                            value={selectedQtyGroup}
                            onChange={(e) => SetSelectedQtyGroup(e.target.value)}
                        >
                            {QtyGroupNameList.length > 0 ? (
                                QtyGroupNameList.map((row) => (
                                    <MenuItem key={row.QtyGroupName} value={row.QtyGroupName}>
                                        {row.QtyGroupName}
                                    </MenuItem>
                                ))
                            ) : null}
                        </Select>
                    </FormControl>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", pb: 2, mt: 1 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => setOpenQtyGroup(false)}
                        sx={{ borderRadius: 2, textTransform: "none" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleQtyGroupSelect}
                        sx={{ borderRadius: 2, textTransform: "none", px: 3, fontWeight: 600, boxShadow: "0px 3px 8px rgba(0,0,0,0.2)" }}
                    >
                        Load
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
}
